import React from "react";
import Page from "components/page/Page";
import Card from "components/card/Card";
import { ButtonNew as Button } from "components/buttonNew";
import "../teeOnPayments.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleCheck } from "@fortawesome/pro-regular-svg-icons";

interface ISetupIntroPageProps {
  onGetStarted: () => void;
}

const setupCards = [
  {
    title: "Integrated terminals",
    description: "Seamlessly sync physical card readers directly with the Tee On POS.",
    image: <img src={"/public/images/teeOnPayments/terminalsCard.svg"} alt="terminal.svg" />,
  },
  {
    title: "Simple rates",
    description: "Transparent, flat-rate pricing on all cards with no hidden fees.",
    image: <img src={"/public/images/teeOnPayments/ratesCard.svg"} alt="rates.svg" />,
  },
  {
    title: "Fast payouts",
    description: "Reliable, automated transfers directly to your connected bank accounts.",
    image: <img src={"/public/images/teeOnPayments/payoutsCard.svg"} alt="payouts.svg" />,
  },
];

export default function TeeOnPaymentsSetup(props: ISetupIntroPageProps) {
  return (
    <Page
      title="Tee On Payments"
      subtitle="View and manage available payment integrations for your facility."
      breadcrumbs={[
        {
          label: "Settings",
          url: "/admin/settings",
        },
        {
          label: "Payments",
          url: "/admin/settings/payments/general",
        },
        {
          label: "Tee On Payments",
          url: "/admin/settings/payments/tee-on-payments",
        },
      ]}
    >
      <Card
        title="Start accepting payments with Tee On"
        subtitle="Streamline your operations with fully integrated payments."
      >
        <Card.Section>
          <Button type="primary" onClick={props.onGetStarted}>
            Get started
          </Button>
        </Card.Section>
      </Card>

      <div className="tee-on-payments-benefits-grid">
        {setupCards.map(item => (
          <div className="tee-on-payments-benefit-card" key={item.title}>
            <div className="tee-on-payments-benefit-card-content">
              <div className="tee-on-payments-benefit-card-content-image">{item?.image}</div>
              <div className="tee-on-payments-benefit-card-content-text">
                <p className="text-md text-semibold text-gray-900 mb-2">
                  <span className="mr-2">
                    <FontAwesomeIcon icon={faCircleCheck} style={{ fontSize: "20px", color: "#039855" }} />
                  </span>
                  {item.title}
                </p>
                <p className="text-xs text-regular text-gray-600">{item.description}</p>
              </div>
            </div>
          </div>
        ))}
      </div>
    </Page>
  );
}
